import { List, Tooltip, Typography } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

const ModelList = ({ model, values, displayLink = true }) => {
  const { t } = useTranslation();

  if (!values?.length > 0) {
    return <></>;
  }

  if (values.length === 1) {
    return displayLink ? (
      <Link to={`/${model}s/${values[0].id}`}>{values[0].name}</Link>
    ) : (
      values[0].name
    );
  }

  const length = values.length - 1;
  const text = `${values[0].name} ${t("global:and")} ${length} ${t(
    "global:otherPlural"
  )}`;

  return (
    <Tooltip
      color="#fff"
      placement="bottom"
      title={
        <List
          size="small"
          dataSource={values}
          renderItem={(item) => {
            return (
              <List.Item>
                {displayLink ? (
                  <Link to={`/${model}s/${item.id}`}>{item.name}</Link>
                ) : (
                  item.name
                )}
              </List.Item>
            );
          }}
        />
      }
    >
      <Typography.Text>{text}</Typography.Text>
    </Tooltip>
  );
};

ModelList.propTypes = {
  model: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  displayLink: PropTypes.bool,
};

export default ModelList;
